/**
 * @file language-helpers.js
 */
(function (Drupal) {
  'use strict';

  Drupal.behaviors.languageHelpers = {
    attach: function (context, settings) {

      /**
       * Hide insight components if they contain no content
       */
      const containersToMonitor = [
        '.paragraph--type--latest-insights-block',
        '.paragraph--type--latest-industry-insights-block',
        '.paragraph--type--latest-product-insights-block'
      ];

      containersToMonitor.forEach((element) => {
        let elem = document.querySelector(element);
        if (elem) {
          if (!elem.querySelector('[class*="js-view-dom"]')) {
            elem.remove();
          }
        }
      });
    }
  };

})(Drupal);
